import { Component, OnInit }        from '@angular/core';

@Component({
    selector: 'app-dashboard',
    template: '<router-outlet></router-outlet>',
})
export class SimpleLayoutComponent implements OnInit {

    constructor() { }

    ngOnInit(): void { }
}



// WEBPACK FOOTER //
// ./src/app/layouts/simple-layout.component.ts